import React from "react";

import Script from "dangerous-html/react";
import { Helmet } from "react-helmet";
import Video from "../vid.mp4";

import Line from "../components/line";
import "./home.css";

const Home = (props) => {
  return (
    <div className="home-container">
      <Helmet>
        <title>DOMINATEE</title>
        <meta property="og:title" content="DOMINATEE" />
      </Helmet>
      <section className="home-hero">
        <video
          src={Video}
          loop
          muted
          poster="https://images.pexels.com/photos/2724749/pexels-photo-2724749.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1260&amp;h=750&amp;dpr=1"
          preload="auto"
          autoPlay
          playsInline
          className="home-video"
        ></video>
        <header data-thq="thq-navbar" className="home-navbar">
          <img alt="image" src="/logo.svg" className="home-branding" />
          <div data-thq="thq-burger-menu" className="home-burger-menu">
            {/* <div className="home-hamburger">
              <img alt="image" src="/hamburger.svg" className="home-icon" />
            </div> */}
          </div>
          <div data-thq="thq-mobile-menu" className="home-mobile-menu">
            <div
              data-thq="thq-mobile-menu-nav"
              data-role="Nav"
              className="home-nav"
            >
              <div className="home-container1">
                <img
                  alt="image"
                  src="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
                  className="home-image"
                />
                <div data-thq="thq-close-menu" className="home-menu-close">
                  <svg viewBox="0 0 1024 1024" className="home-icon01">
                    <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                  </svg>
                </div>
              </div>
              <nav
                data-thq="thq-mobile-menu-nav-links"
                data-role="Nav"
                className="home-nav1"
              >
                <span className="home-text">About</span>
                <span className="home-text01">Features</span>
                <span className="home-text02">Pricing</span>
                <span className="home-text03">Team</span>
                <span className="home-text04">Blog</span>
              </nav>
              <div className="home-container2">
                <button className="home-login button">Login</button>
                <button className="button">Register</button>
              </div>
            </div>
            <div className="home-icon-group">
              <svg viewBox="0 0 950.8571428571428 1024" className="home-icon03">
                <path d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"></path>
              </svg>
              <svg viewBox="0 0 877.7142857142857 1024" className="home-icon05">
                <path d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"></path>
              </svg>
              <svg viewBox="0 0 602.2582857142856 1024" className="home-icon07">
                <path d="M548 6.857v150.857h-89.714c-70.286 0-83.429 33.714-83.429 82.286v108h167.429l-22.286 169.143h-145.143v433.714h-174.857v-433.714h-145.714v-169.143h145.714v-124.571c0-144.571 88.571-223.429 217.714-223.429 61.714 0 114.857 4.571 130.286 6.857z"></path>
              </svg>
            </div>
          </div>
        </header>
        <div className="home-hero-content">
          <div className="home-header-container">
            <div className="home-header">
              <h1 className="home-heading">
                <span>FUTURE IS HERE.</span>
                <br></br>
              </h1>
            </div>
            <p className="home-caption">
              Switch to Future with DOMINATEE Home Automation Devices. Your
              convenience is our Satisfaction.
            </p>
          </div>
          <button
            className="home-button button"
            onClick={() => window.scrollTo({ top: 5500, behavior: "smooth" })}
          >
            <span>
              <span>Get an instant estimate</span>
              <br></br>
            </span>
          </button>
        </div>
      </section>
      <section className="home-experience">
        <div className="home-images">
          <div className="home-square"></div>
          <img
            alt="image"
            src="https://images.pexels.com/photos/14598479/pexels-photo-14598479.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1260&amp;h=750&amp;dpr=1"
            className="home-image1"
          />
        </div>
        <div className="home-content">
          <div className="home-header01">
            <div className="home-header-container1">
              <div className="home-header02">
                <h2 className="home-heading1">
                  <span>Key Features</span>
                  <br></br>
                </h2>
              </div>
              <p className="home-caption1">
                Cost effective latest technology. 
              </p>
            </div>
            <div className="home-checkmarks">
              <div className="home-check">
                <div className="home-mark">
                  <svg viewBox="0 0 1024 1024" className="home-icon09">
                    <path d="M823.168 225.835l-439.168 439.168-183.168-183.168c-16.683-16.683-43.691-16.683-60.331 0s-16.683 43.691 0 60.331l213.333 213.333c16.683 16.683 43.691 16.683 60.331 0l469.333-469.333c16.683-16.683 16.683-43.691 0-60.331s-43.691-16.683-60.331 0z"></path>
                  </svg>
                </div>
                <span className="home-text12">
                  When it&apos;s time it&apos;s ON 
                </span>
              </div>
              <div className="home-check1">
                <div className="home-mark01">
                  <svg viewBox="0 0 1024 1024" className="home-icon11">
                    <path d="M823.168 225.835l-439.168 439.168-183.168-183.168c-16.683-16.683-43.691-16.683-60.331 0s-16.683 43.691 0 60.331l213.333 213.333c16.683 16.683 43.691 16.683 60.331 0l469.333-469.333c16.683-16.683 16.683-43.691 0-60.331s-43.691-16.683-60.331 0z"></path>
                  </svg>
                </div>
                <span className="home-text13">
                  Compatible with all Voice Assistant
                </span>
              </div>
              <div className="home-check2">
                <div className="home-mark02">
                  <svg viewBox="0 0 1024 1024" className="home-icon13">
                    <path d="M823.168 225.835l-439.168 439.168-183.168-183.168c-16.683-16.683-43.691-16.683-60.331 0s-16.683 43.691 0 60.331l213.333 213.333c16.683 16.683 43.691 16.683 60.331 0l469.333-469.333c16.683-16.683 16.683-43.691 0-60.331s-43.691-16.683-60.331 0z"></path>
                  </svg>
                </div>
                <span className="home-text14">
                  Real-time device status monitoring
                </span>
              </div>
              <div className="home-check3">
                <div className="home-mark03">
                  <svg viewBox="0 0 1024 1024" className="home-icon15">
                    <path d="M823.168 225.835l-439.168 439.168-183.168-183.168c-16.683-16.683-43.691-16.683-60.331 0s-16.683 43.691 0 60.331l213.333 213.333c16.683 16.683 43.691 16.683 60.331 0l469.333-469.333c16.683-16.683 16.683-43.691 0-60.331s-43.691-16.683-60.331 0z"></path>
                  </svg>
                </div>
                <span className="home-text15">
                  Control from anywhere, anytime
                </span>
              </div>
            </div>
          </div>
          <div className="home-testimonial">
            <div className="home-content01">
              <span className="home-text16">Testimonial</span>
              <p className="home-text17">
                &quot;Earlier it was only possible in movies but now with
                DOMINATEE products everything just feels real.&quot;
              </p>
            </div>
            <div className="home-information">
              <div className="home-author">
                <img
                  alt="image"
                  src="https://images.pexels.com/photos/726162/pexels-photo-726162.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1260&amp;h=750&amp;dpr=1"
                  className="home-icon17"
                />
                <span className="home-name">
                  <span>Anria Space</span>
                  <br></br>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="home-growth">
        <div className="home-content02">
          <div className="home-header03">
            <div className="home-header04">
              <h2 className="home-heading2">
                <span>Retrofit Modules</span>
                <br></br>
              </h2>
            </div>
            <p className="home-caption2">
              <span>
                Retrofit Modules allow you to control your old mechanical
                switches from virtually anywhere by installing them inside your
                switchbox. In addition, it is compatible with all voice
                assistants. 
              </span>
              <br></br>
            </p>
          </div>
          <div className="home-testimonial1">
            <div className="home-content03">
              <span className="home-text24">Testimonial</span>
              <p className="home-text25">
                It&apos;s great for someone who is looking for renovations
                because it completely changes your lifestyle. It&apos;s fast
                because it maps with local servers.&quot;
              </p>
            </div>
            <div className="home-information1">
              <div className="home-author1">
                <img
                  alt="image"
                  src="https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1260&amp;h=750&amp;dpr=1"
                  className="home-icon18"
                />
                <span className="home-name1">Justin Shaifer</span>
              </div>
            </div>
          </div>
        </div>
        <div className="home-images1">
          <div className="home-square1"></div>
          <img
            alt="image"
            src="https://images.pexels.com/photos/6283961/pexels-photo-6283961.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1260&amp;h=750&amp;dpr=1"
            className="home-image2"
          />
        </div>
      </section>
      <section className="home-statistics">
        <div className="home-content04">
          <div className="home-stat">
            <h3 className="home-header05">11000+</h3>
            <span className="home-caption3">Devices Automated</span>
          </div>
          <div className="home-stat1">
            <h3 className="home-header06">800+</h3>
            <span className="home-caption4">Projects Worldwide</span>
          </div>
          <div className="home-stat2">
            <h3 className="home-header07">40+</h3>
            <span className="home-caption5">
              <span>Worldwide distributors</span>
              <br></br>
            </span>
          </div>
        </div>
      </section>
      <section className="home-get-started">
        <div className="home-header-container2">
          <div className="home-header08">
            <h2 className="home-heading3">
              <span className="home-text28">
                DOMINATEE.
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <br className="home-text29"></br>
              <span className="home-text30">
                The
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <span className="home-text31">last </span>
              <span>
                word
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <br></br>
              <span>of Automation.</span>
              <br></br>
            </h2>
            <p className="home-caption6">
              <span>
                Dominating present problems
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <br></br>
              <span>with futureproof products. </span>
            </p>
          </div>
          <div className="home-button1">
            {/* <button className="button">
              <span>
                <span>Switch to future with us -&gt;</span>
                <br></br>
              </span>
            </button> */}
          </div>
        </div>
        <img alt="image" src="/getstarted-800w.png" className="home-image3" />
      </section>
      <section className="home-objectives">
        <div className="home-content05">
          <div className="home-objectives-list">
            <div className="objective">
              <h3 className="home-text42">
                <span>Design</span>
                <br></br>
              </h3>
              <p className="home-text45">
                <span>
                  Our products are designed by experts so that it works well
                  with experience. Equiped with latest 
                </span>
                <br></br>
                <span>technology to ensure reliability.</span>
                <br></br>
              </p>
            </div>
            <div className="objective home-objective1">
              <h3 className="home-text50">Optimize</h3>
              <p className="home-text51">
                We took our most time to optimize the products to work in order
                so you will have better control and its made easy to operate.
              </p>
            </div>
            <div className="objective home-objective2">
              <h3 className="home-text52">Develop</h3>
              <p className="home-text53">
                <span>
                  Developed in very high quality labs with proper ESD protection
                  to provide long lasting life to
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
                <br></br>
                <span>all our products.</span>
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="home-comparision">
        <div className="home-header-container3">
          <div className="home-header09">
            <h2 className="home-heading4">
              <span>Device Comparison</span>
              <br></br>
            </h2>
          </div>
        </div>
        <div className="home-table">
          <div className="home-row">
            <div className="home-headers">
              <span className="home-text59">Placeholder</span>
            </div>
            <div className="home-plans">
              <div className="home-row01">
                <span className="home-text60">Dominatee</span>
                <span className="home-text61">other</span>
              </div>
            </div>
          </div>
          <div className="home-row02">
            <div className="home-headers1">
              <span className="home-text62">
                Server based on product sold region
              </span>
            </div>
            <div className="home-plans1">
              <div className="home-row03">
                <div className="value">
                  <div className="home-mark04">
                    <svg viewBox="0 0 1024 1024" className="home-icon19">
                      <path d="M823.168 225.835l-439.168 439.168-183.168-183.168c-16.683-16.683-43.691-16.683-60.331 0s-16.683 43.691 0 60.331l213.333 213.333c16.683 16.683 43.691 16.683 60.331 0l469.333-469.333c16.683-16.683 16.683-43.691 0-60.331s-43.691-16.683-60.331 0z"></path>
                    </svg>
                  </div>
                </div>
                <div className="value">
                  <Line></Line>
                </div>
              </div>
            </div>
          </div>
          <div className="home-row06">
            <div className="home-headers3">
              <span className="home-text66">
                Works with all Voice Assistants 
              </span>
            </div>
            <div className="home-plans3">
              <div className="home-row07">
                <div className="value">
                  <div className="home-mark06">
                    <svg viewBox="0 0 1024 1024" className="home-icon23">
                      <path d="M823.168 225.835l-439.168 439.168-183.168-183.168c-16.683-16.683-43.691-16.683-60.331 0s-16.683 43.691 0 60.331l213.333 213.333c16.683 16.683 43.691 16.683 60.331 0l469.333-469.333c16.683-16.683 16.683-43.691 0-60.331s-43.691-16.683-60.331 0z"></path>
                    </svg>
                  </div>
                </div>
                <div className="value">
                  <Line></Line>
                </div>
              </div>
            </div>
          </div>
          <div className="home-row10">
            <div className="home-headers5">
              <span className="home-text68">24 Hours Service Desk</span>
            </div>
            <div className="home-plans5">
              <div className="home-row11">
                <div className="value">
                  <div className="home-mark09">
                    <svg viewBox="0 0 1024 1024" className="home-icon29">
                      <path d="M823.168 225.835l-439.168 439.168-183.168-183.168c-16.683-16.683-43.691-16.683-60.331 0s-16.683 43.691 0 60.331l213.333 213.333c16.683 16.683 43.691 16.683 60.331 0l469.333-469.333c16.683-16.683 16.683-43.691 0-60.331s-43.691-16.683-60.331 0z"></path>
                    </svg>
                  </div>
                </div>
                <div className="value">
                  <Line></Line>
                </div>
              </div>
            </div>
          </div>
          <div className="home-row10">
            <div className="home-headers5">
              <span className="home-text68">2 Years warranty then AMC</span>
            </div>
            <div className="home-plans5">
              <div className="home-row11">
                <div className="value">
                  <div className="home-mark09">
                    <svg viewBox="0 0 1024 1024" className="home-icon29">
                      <path d="M823.168 225.835l-439.168 439.168-183.168-183.168c-16.683-16.683-43.691-16.683-60.331 0s-16.683 43.691 0 60.331l213.333 213.333c16.683 16.683 43.691 16.683 60.331 0l469.333-469.333c16.683-16.683 16.683-43.691 0-60.331s-43.691-16.683-60.331 0z"></path>
                    </svg>
                  </div>
                </div>
                <div className="value">
                  <Line></Line>
                </div>
              </div>
            </div>
          </div>
          <div className="home-row10">
            <div className="home-headers5">
              <span className="home-text68">Customized UI</span>
            </div>
            <div className="home-plans5">
              <div className="home-row11">
                <div className="value">
                  <div className="home-mark09">
                    <svg viewBox="0 0 1024 1024" className="home-icon29">
                      <path d="M823.168 225.835l-439.168 439.168-183.168-183.168c-16.683-16.683-43.691-16.683-60.331 0s-16.683 43.691 0 60.331l213.333 213.333c16.683 16.683 43.691 16.683 60.331 0l469.333-469.333c16.683-16.683 16.683-43.691 0-60.331s-43.691-16.683-60.331 0z"></path>
                    </svg>
                  </div>
                </div>
                <div className="value">
                  <Line></Line>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="home-faq">
        <div className="home-header10">
          <h2 className="home-heading5">
            <span>Frequently asked </span>
            <span className="home-text70">questions</span>
            <span>
              <span
                dangerouslySetInnerHTML={{
                  __html: " ",
                }}
              />
            </span>
          </h2>
        </div>
        <div className="home-content06">
          <div className="home-column">
            <div className="home-element">
              <h3 className="home-header11">
                <span>How long is the warranty ?</span>
                <br></br>
              </h3>
              <p className="home-content07">
                All our products have standard 5 years warranty and on demand
                repair withing 48 hours for a lifetime.
              </p>
            </div>
          </div>
          <div className="home-column1">
            <div className="home-element1">
              <h3 className="home-header12">
                Does Retrofit modules fit inside ?
              </h3>
              <p className="home-content08">
                It is small in size and fits in almost all switchbox. Its
                64x35x24 mm. 
              </p>
            </div>
          </div>
        </div>
        {/* <button className="home-button3 button">
          <span>
            <span>More Q &amp; A -&gt;</span>
            <br></br>
          </span>
        </button> */}
      </section>
      <div className="home-footer">
        <div className="home-content09">
          <div className="home-main">
            <div className="home-branding1">
              <img alt="image" src="/logo.svg" className="home-image4" />
              <span className="home-text77">
                <span>For all your Automation requirements contact us - </span>
                <span>info@dominate.com</span>
                <br></br>
                <span>+91 9048843216, </span>
                <span>+91 9048812343</span>
                <br></br>
              </span>
            </div>
          </div>
          <div className="home-bottom">
            <span className="home-text84">
              © 2024 DOMINATEE - All rights reserved
            </span>
            <button
              data-role="scroll-top"
              className="home-button4 button"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              <img alt="image" src="/arrow.svg" className="home-image5" />
            </button>
          </div>
        </div>
      </div>
      {/* <div>
        <div className="home-container4">
          <Script
            html={`<script>
document.addEventListener("DOMContentLoaded", function() {
  // get the element with the "scroll-top" data-role
  const scrollTopBtn = document.querySelector('[data-role="scroll-top"]');

  // when the element is clicked
  scrollTopBtn.addEventListener("click", function() {
    // smoothly scroll to the top of the page
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
});
</script>
`}
          ></Script>
        </div>
      </div> */}
    </div>
  );
};

export default Home;
